import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/pro/App'

ReactDOM.render(
  <App user={window.CHESSIFY_USER} />,
  document.getElementById('dashboard')
);

module.hot.accept();
